import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

export default function PublicTWPaymentResult({ type = 'success' }) {
  const [params] = useSearchParams();
  const receipt = params.get('receipt');
  const msg = params.get('msg');

  const isSuccess = type === 'success';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-xl border border-gray-200 p-8 max-w-md w-full text-center shadow-sm">
        <div className={`w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 ${isSuccess ? 'bg-green-100' : 'bg-red-100'}`}>
          {isSuccess ? (
            <svg className="w-6 h-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          ) : (
            <svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          )}
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-2">
          {isSuccess ? 'Payment Successful' : 'Payment Failed'}
        </h2>
        <p className="text-sm text-gray-500 mb-4">
          {isSuccess
            ? (receipt
              ? `Your card payment was processed. Receipt: ${receipt}`
              : 'Your card payment was processed successfully.')
            : (msg
              ? `Payment could not be completed (${msg.replace(/_/g, ' ')}).`
              : 'Payment could not be completed. Please try again or use another method.')}
        </p>
        {!isSuccess && (
          <p className="text-xs text-gray-400 mb-4">You can close this page and use the payment link from your email to try again.</p>
        )}
      </div>
    </div>
  );
}
